const EMAIL_PATTERN = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

// Stricter email prefix pattern to check for valid characters and sequence
// This adds the Unicode range \u00C0-\u00FF which includes Latin-1 Supplement characters like é, ü, ñ, etc.
const EMAIL_LOCAL_PART_PATTERN = /^[a-zA-Z0-9\u00C0-\u00FF]+([\._\-+][a-zA-Z0-9\u00C0-\u00FF]+)*$/;

export interface IToolboxValidateEmailResponse {
    valid: boolean;
    email?: string;
    reason?: string;
}

/**
 * Validate email address
 *
 * This function helps on validating if the given email is valid or not.
 * It is recommended to use the returned email response as this function will clean the email address from unexpected whitespaces and zero-width spaces
 *
 * @param email
 */
export function validateEmail(email: string): IToolboxValidateEmailResponse {
    if (typeof email !== 'string') {
        return {
            valid: false,
            email,
            reason: 'Email must be a string',
        };
    }

    const email_lowercase = email
        .replace(/[\u200B-\u200D\uFEFF]/g, '')
        .trim()
        .toLowerCase();

    if (email_lowercase.length > 254) {
        return {
            valid: false,
            email: email_lowercase,
            reason: 'Email format is invalid',
        };
    }

    if (!EMAIL_PATTERN.test(email_lowercase)) {
        return {
            valid: false,
            email: email_lowercase,
            reason: 'Email format is invalid',
        };
    }

    const [prefix] = email_lowercase.split('@');
    if (prefix.length > 64) {
        return {
            valid: false,
            email: email_lowercase,
            reason: 'Email local part format is invalid',
        };
    }

    if (!EMAIL_LOCAL_PART_PATTERN.test(prefix)) {
        return {
            valid: false,
            email: email_lowercase,
            reason: 'Email local part format is invalid',
        };
    }

    return {
        valid: true,
        email: email_lowercase,
    };
}
